import React, { useEffect, useMemo, useState } from "react";
import { DatePicker } from "antd";
import { useSelector } from "react-redux";
import useCurrentPath, {
  downloadMonthWiseExpenseRequestReport,
} from "../../components/Constants";
import ExpenseMultitasking from "../../components/ExpenseMultitasking";
import moment from "moment";

export default function PendingRequests() {
  const { RangePicker } = DatePicker;
  const [showLoader, setShowLoader] = useState(false);
  const [searchFilterData, setSearchFilterData] = useState("");
  const currentPath = useCurrentPath();
  let storeRole = useSelector((state) => state.auth.role);
  let storeToken = useSelector((state) => state.auth.accessToken);
  let storeLIUId = useSelector((state) => state.auth.lIUId);
  const storeAccessTokenExpiresOn = useSelector(
    (state) => state.auth.accessTokenExpiresOn
  );
  const storeList = useSelector(
    (state) => state.auth.list?.[currentPath + "_info"] || []
  );

  const ercount = useSelector((state) => {
    return state.auth.ercount;
  });

  // Memoize filteredList
  const filteredList = useMemo(() => {
    // Ensure decrypted is an array before calling map
    if (Array.isArray(storeList)) {
      return storeList.map(({ key, id, ...rest }) => rest);
    }

    // Return an empty array if decryption fails or result is not an array
    return [];
  }, [storeList]);

  const [filteredData, setFilteredData] = useState([]);
  const [isFilteredDates, setIsFilteredDates] = useState(false);
  const [filterValues, setFilterValues] = useState(null);

  // const handleMonthChange = (monthVal) => {
  //   setFilterValues(monthVal);
  //   setIsFilteredDates(true);
  // };

  const handleMonthRangeChange = (range) => {
    setSearchFilterData("");
    if (range && range.length === 2) {
      const startMonth = range[0]?.format("YYYY-MM");
      const endMonth = range[1]?.format("YYYY-MM");

      setFilterValues({ startMonth, endMonth });
      setIsFilteredDates(true);
    } else {
      setFilterValues(null);
      setIsFilteredDates(false);
    }
  };

  const startMonth = moment("2023-11", "YYYY-MM");
  const endMonth = moment();
  const disabledDate = (current) => {
    return (
      current &&
      (current < startMonth.startOf("month") ||
        current > endMonth.endOf("month"))
    );
  };

  // Callback to get filtered data from ExpenseMultitasking
  const handleFilteredData = (data) => {
    setFilteredData(data);
  };
  // Use useEffect to update filteredData when filteredList changes
  useEffect(() => {
    if (!isFilteredDates && filteredData !== filteredList) {
      setFilteredData(filteredList);
    }
  }, [filteredList, isFilteredDates]);

  const handleDownloadMWERReport = async () => {
    const hasSearchValue = document.querySelector(
      ".dashboardSearch span input"
    ).value;
    setShowLoader(true);
    downloadMonthWiseExpenseRequestReport(
      storeRole,
      storeToken,
      storeLIUId,
      storeAccessTokenExpiresOn,
      currentPath,
      [
        process.env.REACT_APP_PENDING_STATUS?.toUpperCase(),
        process.env.REACT_APP_NORESPONSE_STATUS.replace(" ", "")?.toUpperCase(),
        process.env.REACT_APP_RESUBMITTED_STATUS?.toUpperCase(),
        process.env.REACT_APP_SEEK_ACK_STATUS.replace(" ", "")?.toUpperCase(),
        process.env.REACT_APP_ACK_REC_STATUS.replace(" ", "")?.toUpperCase(),
      ],
      hasSearchValue,
      setShowLoader
    );
  };

  return (
    <div className="container">
      <div className="card bgi-no-repeat card-stretch gutter-b border-2 rounded-lg p-5">
        <div className="d-flex justify-content-between">
          <h3 className="font-weight-boldest text-dark text-size-16 m-0">
            Pending Requests
            <span
              className="label label-dark ml-2 text-white font-weight-bold w-30px h-30px"
              style={{ fontSize: "11px" }}
            >
              {ercount ? ercount : 0}
            </span>
          </h3>
          <div className="card-toolbar d-flex m-0">
            <div className="bg-gray-200 border border-light-dark mr-5 pl-3 rounded text-dark-custom">
              <span className="font-weight-bolder m-0 mr-3">Filter</span>
              <RangePicker
                picker="month"
                format="MMM YYYY"
                disabledDate={disabledDate}
                onChange={handleMonthRangeChange}
                className="border-0 h-100 rangepicker"
              />
            </div>
            <button
              className="border border-light-dark btn font-weight-bolder px-4 py-2 text-dark-custom bg-transparent export-excel-button download-button"
              onClick={() => {
                handleDownloadMWERReport();
              }}
            >
              <i className="fas fa-file-download mr-1"></i>Download Excel
            </button>
          </div>
        </div>

        <div className="table-area mt-10">
          <div className="table-responsive" id="alltable-size">
            <ExpenseMultitasking
              recordLimit={"20"}
              status={[
                process.env.REACT_APP_PENDING_STATUS?.toUpperCase(),
                process.env.REACT_APP_NORESPONSE_STATUS.replace(
                  " ",
                  ""
                ).toUpperCase(),

                process.env.REACT_APP_RESUBMITTED_STATUS?.toUpperCase(),
                process.env.REACT_APP_SEEK_ACK_STATUS.replace(
                  " ",
                  ""
                )?.toUpperCase(),
                process.env.REACT_APP_ACK_REC_STATUS.replace(
                  " ",
                  ""
                )?.toUpperCase(),
              ]}
              showLoaderOnList="yes"
              isFilterSelected={filterValues}
              searchFilterData={searchFilterData}
              setSearchFilterData={setSearchFilterData}
              onFilteredData={handleFilteredData} // Pass callback function
            />
          </div>
        </div>
      </div>
    </div>
  );
}
